import React from 'react'
import {Button} from '../@primitives/button'

import styled from 'react-emotion'
import { colors } from '../../styles/vars'

const Card = styled('div')`
  text-align: center;
  
  p.large {
    color: ${colors.primary}; 
  }
  
  p:last-of-type {
    margin-bottom: 40px;
  }
`

export const TextCard = (props) =>
  <Card>
    <p className="large">{props.heading}</p>
    <p>{props.copy}</p>
    {props.href &&
      <Button href={props.href} />
    }
  </Card>


// WEBPACK FOOTER //
// ./src/components/TextCard/index.js